var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableEmptyState, TableHead, TableLoadingState, TableRow, TableSortLabel, } from '../table';
import { Text } from '../text';
import { DataTableRow } from './data-table-row';
var isSortableColumn = function (column) {
    return !!column.sortable;
};
var DataTableImpl = function (props, ref) {
    var items = props.items, hover = props.hover, columns = props.columns, onRowClick = props.onRowClick, onSort = props.onSort, sortDirection = props.sortDirection, sortOn = props.sortOn, _a = props.emptyMessage, emptyMessage = _a === void 0 ? 'There are no items to display.' : _a, _b = props.isLoading, isLoading = _b === void 0 ? false : _b, _c = props.hideHeader, hideHeader = _c === void 0 ? false : _c, renderItemDetails = props.renderItemDetails, rowRenderer = props.rowRenderer, _d = props.keyExtractor, keyExtractor = _d === void 0 ? function (_item, index) { return index; } : _d, containerProps = __rest(props, ["items", "hover", "columns", "onRowClick", "onSort", "sortDirection", "sortOn", "emptyMessage", "isLoading", "hideHeader", "renderItemDetails", "rowRenderer", "keyExtractor"]);
    var showEmptyState = !isLoading && !items.length;
    return (React.createElement(TableContainer, __assign({}, containerProps, { ref: ref }),
        React.createElement(Table, null,
            !hideHeader && (React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    props.columns.map(function (column, index) {
                        if (!column) {
                            return null;
                        }
                        var isActiveSort = isSortableColumn(column) && sortOn === column.field;
                        var activeSortDirection = sortDirection || 'asc';
                        return (React.createElement(TableCell, { width: column.width, key: index, sortDirection: sortDirection, padding: column.padding }, isSortableColumn(column) && onSort ? (React.createElement(TableSortLabel, { active: isActiveSort, direction: activeSortDirection, onClick: function () {
                                return onSort(column.field, !isActiveSort ? activeSortDirection : activeSortDirection === 'asc' ? 'desc' : 'asc');
                            } }, column.title)) : (column.title)));
                    }),
                    !!renderItemDetails && React.createElement(TableCell, null)))),
            React.createElement(TableBody, null, props.items.map(function (item, index) {
                return (React.createElement(DataTableRow, { hideHeader: hideHeader, hover: hover, columns: columns, key: keyExtractor(item, index), item: item, index: index, componentRenderer: rowRenderer, onRowClick: onRowClick, renderItemDetails: renderItemDetails }));
            }))),
        isLoading && React.createElement(TableLoadingState, { items: items }),
        showEmptyState && (React.createElement(TableEmptyState, null,
            React.createElement(Text, { variant: "body2" }, emptyMessage)))));
};
export var DataTable = React.forwardRef(DataTableImpl);
